import React from 'react';

import TwoWayToggle from '../../../Common/TwoWayToggle/index';

const PercentageAbsoluteToggle = ({ value, onChange }) => <TwoWayToggle
  option1="percentage"
  label1="Percentage"
  option2="absolute"
  label2="Absolute"
  value={value}
  onChange={onChange}
/>;

export default PercentageAbsoluteToggle;


// WEBPACK FOOTER //
// ./src/components/Reports/JobReport/toggles/PercentageAbsoluteToggle.js